import { render } from "./SustainabilityHero2025.vue?vue&type=template&id=50bd5c06&scoped=true"
import script from "./SustainabilityHero2025.vue?vue&type=script&lang=js"
export * from "./SustainabilityHero2025.vue?vue&type=script&lang=js"

import "./SustainabilityHero2025.vue?vue&type=style&index=0&id=50bd5c06&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bd5c06"]])

export default __exports__